import { render, staticRenderFns } from "./RejectionForm.vue?vue&type=template&id=fc568906&scoped=true&"
import script from "./RejectionForm.vue?vue&type=script&lang=ts&"
export * from "./RejectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionForm.vue?vue&type=style&index=0&id=fc568906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc568906",
  null
  
)

export default component.exports